<script>
/* global fbq */
import { ref, onMounted, onBeforeUnmount, computed } from 'vue';
//import { useRouter } from 'vue-router';
import axios from 'axios';
import { useI18n } from 'vue-i18n';
import { useToast } from 'vue-toastification'
import { VueRecaptcha } from 'vue-recaptcha';
// import LanguageSelector from '@/components/language-component.vue';
import Footer from "@/components/footer";
import ScrollArrow from '@/components/ScrollArrow.vue';
import Gauge from '@/components/Gauge.vue';
import FlipClock from "@/components/FlipClock";
import ResultBox from '@/components/ResultBox.vue';
import Lottie from "@/components/widgets/lottie.vue";
import animationSuccess from "@/components/widgets/Animation-1701822503345.json";
import animationFailure from "@/components/widgets/Animation-1701855501291_grande.json";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

import '@/assets/css/spinner/pong.css'; 

export default {
  name: 'Home',
  components: {
    VueRecaptcha,
    Lottie,
    ScrollArrow,
    ResultBox,
    FlipClock,
    Footer,
    Gauge,
    Multiselect
  },
  setup() {
    //const router = useRouter();
    const { t } = useI18n();
    const toast = useToast()

    const showSuccessModal = ref(false);
    const showErrorModal = ref(false);
    const showDKIMErrorModal = ref(false);
    const checkDomainAnimation = ref(false);
    const showResults = ref(false);
    const showForm = ref(true);
    const checkSubdomainAnimation = ref(false);
    const dominioInserito = ref('');
    const dominio = ref('');
    const nome = ref('');
    const primoCheckbox = ref(false);
    const email = ref('');
    const emailInput = ref('');
    const nsList = ref([]);
    const wsList = ref([]);
    const mxList = ref([]);
    const replicList = ref([]);
    const spfText = ref('');
    const serviceRecords = ref([]);
    const checks = ref([]);
    const mailSecurityText = ref('');
    const webSecurityText = ref('');
    const mailTrafficLight = ref('');
    const webTrafficLight = ref('gray');
    const isShodanUpdating = ref(false); // Indica se updateShodanStatus è in esecuzione
    const siteKeyreCAPTCHA = ref('6Lf62AsqAAAAAIXnCP_637dZjF-Y6csgCO1Kf_Jx');
    const recaptchaToken = ref('');
    const recaptchaRef = ref(null);

    const spfScore = ref(0);
    const dmarcScore = ref(0);
    const dkimScore = ref(0);
    const mediaMailScore = ref(0);
    const shodan_score = ref(0);
    const finaleScore = ref(0);
    const numberOfAllowedIps = ref(0);
    const subdomainRecords = ref([]);
    const subdomainStart = ref(0);
    const totalSubdomains = ref(0);  // Store the total number of subdomains
    const dkimStatus = ref('');
    const selectorsOptions = ref([]);
    const selectorsMultiselect1 = ref([]);
    const selectorsMultiselect2 = ref([]);
    const showSuggestionMultiselect = ref(false);
    const historyID = ref(null);

    const shodanAnimationInterval = ref(null);

    const prezzoProdotto = ref(0);
    const nomeProdotto = ref('');
    const valoreProdotto = ref('');
    const linkPagamentoScontato = ref('');
    const linkPagamentoPieno = ref('');
    const valuta = ref('');

    const stripeBaseLink = ref('');
    const showMouseOverMessage = ref(false);
    const isSubmittingForm = ref(false);
    const isCheckoutButtonDisabled = ref(false);

    const errorMessage = ref('');

    const modificaTestoMultiselect = (searchQuery) => {
      showSuggestionMultiselect.value = searchQuery.length > 0;
    };

    const isFormValid = computed(() => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      return emailRegex.test(email.value) && primoCheckbox.value && nome.value;
    });

    const handleSuccess = token => {
      console.log('reCAPTCHA token received:', token);
      recaptchaToken.value = token;
    };

    const handleError = () => { 
      console.log('reCAPTCHA ERRORE');
      recaptchaToken.value = ''; 
    };

    const handleTimerEnd = () => {
      stripeBaseLink.value = linkPagamentoPieno.value;
      console.log(`URL stripe: ${stripeBaseLink.value}`);
    };

    const isSwissIP = ref(false);

    const checkIP = async () => {
      try {
        const response = await axios.get(`${process.env.VUE_APP_BACKEND_URL}/api/check-ip/`);
        isSwissIP.value = response.data.is_swiss_ip;
      } catch (error) {
        console.error('Errore nel determinare la valutaIniziale:', error);
      }
    };

    const reportScanError = async () => {
      console.log('Reporting scan error...');
      console.log('Domain:', dominio.value);
      console.log('Error message:', errorMessage.value);
      console.log('Selectors:', selectorsMultiselect1.value);

      try {
        await axios.post(`${process.env.VUE_APP_BACKEND_URL}/api/scan-error`, {
          domain: dominio.value,
          error: errorMessage.value,
          selectors: selectorsMultiselect1.value.join(",")
        });
        console.log('Error reported to scan-error endpoint');
      } catch (reportError) {
        console.error('Failed to report error to scan-error endpoint:', reportError);
      }
    };

    const checkDomain = async (dominio, recaptchaToken) => {
      console.log(`Starting domain check for: ${dominio}`);

      const _fbp = getCookie('_fbp');
      const _fbc = getCookie('_fbc');
      const userAgent = navigator.userAgent;
      const currentPageUrl = window.location.href;

      try {
        const requestData = {
          _fbp: _fbp,
          _fbc: _fbc,
          user_agent: userAgent,
          domain: dominio,
          selettori: Array.isArray(selectorsMultiselect1.value) ? selectorsMultiselect1.value : [],
          recaptchaToken: recaptchaToken,
          page_url: currentPageUrl
        };

        const response = await axios.post(`${process.env.VUE_APP_BACKEND_URL}/api/check-domain/`, requestData);
        if (response.status === 200) {
          const data = response.data;

          const { 
            nameservers = [], // Se `data.nameservers` è undefined o null, assegna un array vuoto `[]` come valore predefinito.
            a_records = [],   // Stessa logica: assegna un array vuoto se non è definito.
            mx_records = [],
            replics = [],
            checks: checkResults = [], // Assegna il valore di `data.checks` alla variabile locale `checkResults`. Valore predefinito: array vuoto.
            service_records = [],
            spf_includes = [],
            spf_score, // Assegna direttamente `data.spf_score` a `spf_score` senza un valore predefinito.
            dmarc_score,
            dkim_score,
            total_score,
            total_count,
            subdomain_records: initialSubdomainRecords, // Rinominazione: assegna `data.subdomain_records` alla variabile `initialSubdomainRecords`.
            new_start,
            total_subdomains,
            dkim_status,
            prezzo_prodotto,
            nome_prodotto,
            valore_prodotto,
            link_pagamento_scontato,
            link_pagamento_pieno,
            valuta_pagamento
          } = data;

          // Aggiorna i dati nel frontend
          nsList.value = nameservers.filter(nsItem => nsItem[1] !== null);
          wsList.value = a_records.filter(wsItem => wsItem[1] !== null);
          mxList.value = mx_records.filter(mxItem => mxItem[1] !== null);
          replicList.value = replics.filter(replicItem => replicItem[1] !== null);
          serviceRecords.value = service_records.filter(serviceItem => serviceItem[1] !== null);
          spfText.value = spf_includes.filter(spfItem => spfItem[1] !== null);
          checks.value = checkResults;

          spfScore.value = spf_score;
          dmarcScore.value = dmarc_score;
          dkimScore.value = dkim_score;
          mediaMailScore.value = total_score;
          numberOfAllowedIps.value = total_count;
          subdomainRecords.value = initialSubdomainRecords;
          subdomainStart.value = new_start;
          totalSubdomains.value = total_subdomains;
          dkimStatus.value = dkim_status;
          selectorsMultiselect2.value = [...selectorsMultiselect1.value];
          prezzoProdotto.value = prezzo_prodotto;
          nomeProdotto.value = nome_prodotto;
          valoreProdotto.value = valore_prodotto;
          linkPagamentoScontato.value = link_pagamento_scontato;
          linkPagamentoPieno.value = link_pagamento_pieno;
          valuta.value = valuta_pagamento;

          stripeBaseLink.value = link_pagamento_scontato;

          updateTextColorMailSecurity();

          let historySetData = {
            domain: dominio,
            spf: JSON.stringify(spfText.value),
            dns: JSON.stringify(nameservers),
            mx: JSON.stringify(mx_records),
            ip_sum: numberOfAllowedIps.value,
            webserver: JSON.stringify(a_records),
            checks: JSON.stringify(checkResults),
            selectors: selectorsMultiselect1.value.join(","), // Convert array to a comma-separated string
            mediaMailScore: mediaMailScore.value
          };

          try {
            const historyResponse = await axios.post(`${process.env.VUE_APP_BACKEND_URL}/api/history-list/`, historySetData);
            console.log('History data submitted:', historyResponse.data);

            historyID.value = historyResponse.data.id;
            console.log('History ID:', historyID.value);
          } catch (error) {
            console.error('Error in saving history:', error);
          }

          // Trigger Facebook Pixel event
          const eventID = data.event_id;
          const eventName = data.event_name;
          fbq('track', eventName, { eventID });
          console.log(`Evento ${eventName} inviato con eventID: ${eventID}`);

          updateShodanStatus();
        } else {
          showErrorModal.value = true;
          errorMessage.value = response.data.error;
          await reportScanError();
        }
      } catch (error) {
        console.error(error);
        showErrorModal.value = true;
        errorMessage.value = error.response?.data.error || 'Si è verificato un errore durante il controllo del dominio.';
        await reportScanError();
      }
    };

    //const goToCheckout = () => { router.push({ name: 'checkout' }); };

    const updateShodanStatus = async () => {
      console.log('Updating Shodan status...');
      isShodanUpdating.value = true; // Start animation
      try {
        const requestData = { domain: dominio.value };

        const response = await axios.post(`${process.env.VUE_APP_BACKEND_URL}/api/check-vulns/`, requestData);
        shodan_score.value = response.data.shodan_score;

        console.log('Shodan status updated:', shodan_score.value);

        // Calcolo della media tra shodan_score e mediaMailScore
        if (typeof mediaMailScore.value === 'number' && typeof shodan_score.value === 'number') {
          finaleScore.value = Math.floor((shodan_score.value + mediaMailScore.value) / 2);
          console.log('Finale score updated:', finaleScore.value);
        } else {
          console.warn('shodan_score or mediaMailScore is not a number. Unable to calculate finaleScore.');
        }

        if (historyID.value) {
          let historyUpdateData = {
            shodan_score: shodan_score.value,
            finaleScore: finaleScore.value
          };

          try {
            await axios.put(`${process.env.VUE_APP_BACKEND_URL}/api/history-update/${historyID.value}/`, historyUpdateData);
            console.log('History shodan_score updated:', historyUpdateData);
          } catch (error) {
            console.error('Error updating history with shodan_score:', error);
          }
        } else {
          console.warn('History ID is not set. Unable to update shodan_score.');
        }

      } catch (error) {
        console.error('Error in Shodan status update:', error);
      } finally {
        isShodanUpdating.value = false; // Stop animation
      }
    };

    const startShodanStatusAnimation = () => {
      console.log('Starting Shodan status animation...');
      const colors = ['red', 'yellow', 'green'];
      let currentIndex = 0;

      const interval = setInterval(() => {
        webTrafficLight.value = colors[currentIndex];
        currentIndex = (currentIndex + 1) % colors.length; // Ciclo tra i colori
      }, 1000);

      return interval; // Restituisce l'intervallo per fermarlo in seguito
    };

    const stopShodanStatusAnimation = (interval) => {
      console.log('Stopping Shodan status animation...');
      clearInterval(interval);
    };

    const handleShodanUpdate = async () => {
      checkDomainAnimation.value = true;
      while (isShodanUpdating.value) {
        await new Promise(resolve => setTimeout(resolve, 1000)); // Poll every 1000ms
      }
      checkDomainAnimation.value = false;

      if (shodanAnimationInterval.value) {
        stopShodanStatusAnimation(shodanAnimationInterval.value);
        shodanAnimationInterval.value = null; // Resetta l'intervallo
      }

      // Set the final color after animation stops
      if (shodan_score.value === 20) {
        webTrafficLight.value = 'red';
        webSecurityText.value = t('semaforo1_web');
      // } else if (shodan_score.value === 80) {
      //   webTrafficLight.value = 'yellow';
      //   webSecurityText.value = t('semaforo2_web');
      } else {
        webTrafficLight.value = 'green';
        webSecurityText.value = t('semaforo3_web');
      }
    };

    const fetchMoreSubdomains = async () => {
      console.log('Fetching more subdomains...');
      checkSubdomainAnimation.value = true;
      try {
        const response = await axios.get(`${process.env.VUE_APP_BACKEND_URL}/api/get-more-subdomains/`, { 
          params: { d: dominio.value, start: subdomainStart.value, count: 25 } 
        });
        const data = response.data;

        if (data && data.subdomain_records) {
          subdomainRecords.value.push(...data.subdomain_records);
          subdomainStart.value = data.new_start; // Update start to the new value from the backend
        }

        console.log('Additional subdomains:', data.subdomain_records);
      } catch (error) {
        console.error('Error fetching more subdomains:', error);
      } finally {
        checkSubdomainAnimation.value = false;
      }
    };

    const updateTextColorMailSecurity = () => {
      const passedCount = checks.value.filter(check => check === 'passed').length;
      if (passedCount === 3) {
        mailSecurityText.value = t('semaforo3');
        mailTrafficLight.value = 'green';
      } else if (passedCount === 2) {
        mailSecurityText.value = t('semaforo2');
        mailTrafficLight.value = 'yellow';
      } else {
        mailSecurityText.value = t('semaforo1');
        mailTrafficLight.value = 'red';
      }
      mailSecurityText.value += t('fine_semaforo');
    };

    const resetFormValues = () => {
      nsList.value = [];
      wsList.value = [];
      mxList.value = [];
      replicList.value = [];
      serviceRecords.value = [];
      spfText.value = [];
      showResults.value = false;
      checks.value = [];
      mailSecurityText.value = '';
      webSecurityText.value = '';
      mailTrafficLight.value = '';
      webTrafficLight.value = '';
      spfScore.value = 0;
      dmarcScore.value = 0;
      dkimScore.value = 0;
      mediaMailScore.value = 0;
      shodan_score.value = 0;
      finaleScore.value = 0;
      numberOfAllowedIps.value = 0;
      subdomainRecords.value = [];
      subdomainStart.value = 0;
      totalSubdomains.value = 0;
      showForm.value = true;
      nome.value = '';
      email.value = '';
      primoCheckbox.value = false;
      dkimStatus.value = '';
      historyID.value = null;
      isSubmittingForm.value = false;
      isCheckoutButtonDisabled.value = false;
    };

    const cleanDomainInput = (input) => {
      try {
        let cleanedInput = input.replace(/(^\w+:|^)\/\//, ''); // Remove protocols like http:// or https://
        cleanedInput = cleanedInput.split('/')[0]; // Remove everything after the domain (only keep the domain part)
        cleanedInput = cleanedInput.toLowerCase(); // Convert to lowercase
        cleanedInput = cleanedInput.replace(/\s+/g, ''); // Remove all spaces
        cleanedInput = cleanedInput.replace(/^www\./i, ''); // Remove 'www.' prefix if present
        return cleanedInput;
      } catch (error) {
        console.error('Error cleaning domain input:', error);
        return input; // Return the original input if there's an error
      }
    };

    const executeRecaptcha = () => {
      return new Promise((resolve) => {
        recaptchaRef.value.execute();
        const checkToken = setInterval(() => {
          if (recaptchaToken.value) {
            clearInterval(checkToken);
            const token = recaptchaToken.value;
            recaptchaToken.value = null; // Reset the token
            resolve(token);
          }
        }, 100);
      });
    };

    const isDomainValid = (input) => {
      const domainRegex = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/i;
      const cleanedInput = cleanDomainInput(input);
      return domainRegex.test(cleanedInput);
    };

    const handleFormSubmission = async () => {
      if (!dominioInserito.value || !isDomainValid(dominioInserito.value)) {
        toast.error("Inserisci un dominio valido per procedere con l'analisi.", {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return
      }

      const token = await executeRecaptcha();

      if (checkDomainAnimation.value) return; // Evita invii multipli
      console.log('Form Submitted.');
      
      // Pulisci l'input prima di assegnarlo a dominio.value
      const cleanedInput = cleanDomainInput(dominioInserito.value);
      console.log('Cleaned Dominio:', cleanedInput);
      
      checkDomainAnimation.value = true;
      resetFormValues();
      dominio.value = cleanedInput;

      if (!shodanAnimationInterval.value) {
        shodanAnimationInterval.value = startShodanStatusAnimation();
      }

      await checkDomain(dominio.value, token);

      checkDomainAnimation.value = false;
      showResults.value = true;

      setTimeout(async () => {
        window.scrollTo({
          top: document.documentElement.scrollTop + window.innerHeight,
          behavior: 'smooth'
        });
      }, 0);
    };

    const handleDkimCheck = async () => {
      try {
        const response = await axios.post(`${process.env.VUE_APP_BACKEND_URL}/api/check-user-selectors/`, {
          domain: dominio.value,
          selectors: selectorsMultiselect2.value,
          spf_score: spfScore.value,
          dmarc_score: dmarcScore.value
        });

        const data = response.data;
        console.log('DKIM and DMARC/SPF check response:', data);

        // Update frontend data based on the response only if DKIM check is successful
        if (data.dkim_results && data.dkim_results.status !== 'failed') {
          selectorsMultiselect1.value = [...selectorsMultiselect2.value];
          dkimStatus.value = data.dkim_results.status;
          dkimScore.value = data.dkim_results.total_dkim_score;

          if (data.dmarc_spf_dkim_results) {
            checks.value = data.dmarc_spf_dkim_results;
          }
          mediaMailScore.value = data.total_score;
          updateTextColorMailSecurity();

          // Update the existing History record using historyID
          if (historyID.value) {
            let historyUpdateData = {
              domain: dominio.value,
              spf: JSON.stringify(spfText.value),
              dns: JSON.stringify(nsList.value),
              mx: JSON.stringify(mxList.value),
              ip_sum: numberOfAllowedIps.value,
              webserver: JSON.stringify(wsList.value),
              checks: JSON.stringify(checks.value),
              selectors: selectorsMultiselect2.value.join(",") // Convert array to a comma-separated string
            };

            try {
              await axios.put(`${process.env.VUE_APP_BACKEND_URL}/api/history-update/${historyID.value}/`, historyUpdateData);
              console.log('History data updated:', historyUpdateData);
            } catch (error) {
              console.error('Error updating history:', error);
            }
          } else {
            console.warn('History ID is not set. Unable to update history.');
          }
        } else {
          console.warn('DKIM check failed; skipping data updates.');
          showDKIMErrorModal.value = true;
        }
      } catch (error) {
        console.error('Error during DKIM selector check:', error);
        showErrorModal.value = true;
      }
    };

    onMounted(async () => {
      const videoElement = document.querySelector('.hero-video');
      videoElement.addEventListener('contextmenu', (e) => e.preventDefault());
      checkIP();
    });

    const currency = computed(() => isSwissIP.value ? 'franchi' : 'euro');

    onBeforeUnmount(() => {
      const videoElement = document.querySelector('.hero-video');
      videoElement.removeEventListener('contextmenu', (e) => e.preventDefault());
      if (shodanAnimationInterval.value) {
        stopShodanStatusAnimation(shodanAnimationInterval.value);
      }
    });

    const getFlag = (countryCode) => {
      if (countryCode === 'PRIVATE_IP') {
        return {
          icon: 'ri-error-warning-line',
          text: t('private_ip_warning'),
          src: null
        };
      } else if (countryCode === 'IPV4_6TO4') {
        return {
          icon: 'ri-global-line',
          text: t('ipv4_6to4'),
          src: null
        };
      }
      return `https://flagcdn.com/${countryCode}.svg`;
    };

    const mailBorderColorClass = computed(() => {
      if (mailTrafficLight.value === 'green') return 'border-green';
      if (mailTrafficLight.value === 'yellow') return 'border-yellow';
      return 'border-red';
    });

    const webBorderColorClass = computed(() => {
      if (webTrafficLight.value === 'green') return 'border-green';
      if (webTrafficLight.value === 'yellow') return 'border-yellow';
      if (webTrafficLight.value === 'red') return 'border-red';
      return 'border-gray'; // Default: grigio
    });

    const getLabelText = (score, type) => {
      console.log(`Input - score: ${score}, type: ${type}`);
      const labels = {
        spf: {
          red: "❌ Urgenza! La tua configurazione è gravemente carente. Molti server non autorizzati potrebbero inviare e-mail a nome tuo, mettendo a rischio la reputazione del tuo dominio. È fondamentale correggere subito per evitare abusi e potenziali conseguenze legali.",
          yellow: "⚠️ Attenzione! La tua configurazione permette ad alcuni server non autorizzati di inviare e-mail a nome tuo. Questo potrebbe compromettere la sicurezza e la credibilità del tuo dominio. Consigliamo correggere subito per evitare abusi e potenziali conseguenze legali.",
          green: "✅ Molto bene! La maggior parte dei server autorizzati è configurata correttamente. Tuttavia, ci sono piccoli dettagli da ottimizzare per garantire una protezione completa contro l’uso improprio del tuo dominio.",
          perfect: "🎉 Perfetto! Solo i server autorizzati possono inviare e-mail a nome tuo. La tua configurazione è impeccabile e garantisce la massima sicurezza contro abusi e utilizzi non autorizzati. Ottimo lavoro!"
        },
        dkim: {
          red: "❌ Grave rischio! Le tue e-mail non sono adeguatamente protette, il che permette a chiunque di falsificarle o modificarle. Questo ti espone a tentativi di frode e phishing che potrebbero danneggiare la reputazione della tua azienda. È fondamentale intervenire immediatamente.",
          yellow: "⚠️ Attenzione! La maggior parte delle tue e-mail è protetta, ma ci sono lacune che potrebbero consentire manipolazioni o falsificazioni. Ti consigliamo di correggere queste configurazioni per garantire maggiore sicurezza alle tue comunicazioni.",
          green: "✅ Molto bene! Le tue e-mail sono quasi completamente protette da falsificazioni e manomissioni. Solo pochi dettagli richiedono attenzione per garantire la sicurezza totale delle tue comunicazioni.",
          perfect: "🎉 Perfetto! L'origine e l'integrità delle tue e-mail sono completamente protette. Nessuno può falsificarle o modificarle, garantendo la massima sicurezza per le tue comunicazioni. Ottimo lavoro!"
        },
        dmarc: {
          red: "❌ Grave rischio! La tua configurazione attuale non protegge il dominio da tentativi di frode e furti d'identità. Questo ti espone a un alto rischio di utilizzi non autorizzati, che possono danneggiare seriamente la reputazione della tua azienda. Agisci subito per correggere queste vulnerabilità!",
          yellow: "⚠️ Attenzione! Il tuo dominio è parzialmente protetto, ma rimangono vulnerabilità che possono essere sfruttate da malintenzionati. Queste lacune potrebbero essere utilizzate per impersonare la tua azienda e compromettere la fiducia dei tuoi clienti. Intervieni per migliorare la configurazione.",
          green: "✅ Molto bene! Il tuo dominio è ben protetto contro frodi e tentativi di furto d'identità. Solo piccoli dettagli richiedono attenzione per assicurarti una protezione completa e duratura.",
          perfect: "🎉 Perfetto! Il tuo dominio è completamente protetto da frodi e tentativi di furto d'identità. La tua configurazione garantisce la massima sicurezza e preserva la fiducia dei tuoi clienti. Ottimo lavoro!"
        },
        avg: {
          red: "❌ Gravissimo rischio! La sicurezza delle tue e-mail è altamente compromessa. Il tuo dominio è vulnerabile a frodi, furti d’identità e utilizzi non autorizzati. Questo non solo può danneggiare gravemente la reputazione della tua azienda, ma potrebbe anche portare a conseguenze legali se il tuo dominio venisse utilizzato per attività illecite. Intervieni immediatamente per risolvere queste criticità e proteggere il tuo business!",
          yellow: "️⚠️ Attenzione! La sicurezza complessiva delle tue e-mail presenta lacune significative. Alcune configurazioni deboli potrebbero esporre il tuo dominio a rischi di frodi e utilizzi impropri. Oltre a compromettere la tua reputazione, potresti trovarti a dover affrontare responsabilità legali in caso di abusi. Agisci ora per rafforzare la protezione!",
          green: "✅ Molto bene! La protezione complessiva delle tue e-mail è solida. Restano solo alcuni aspetti minori da perfezionare per garantire una sicurezza totale e prevenire qualsiasi rischio futuro.",
          perfect: "🎉 Perfetto! La sicurezza complessiva delle tue e-mail è al massimo livello. Ogni configurazione è ottimale, garantendo protezione totale e prevenendo qualsiasi rischio per il tuo dominio. Complimenti per il risultato eccellente!"
        },
        web: {
          red: "❌ Urgenza! I tuoi servizi web presentano gravi rischi di esposizione. Alcuni sistemi o applicazioni potrebbero essere vulnerabili o accessibili a malintenzionati, mettendo a rischio la sicurezza dei dati aziendali. Questo test, basato su dati pubblici, evidenzia problemi che necessitano di interventi immediati. Consigliamo di approfondire con un’analisi più dettagliata.",
          yellow: "⚠️ Attenzione! Ci sono configurazioni o servizi che potrebbero rappresentare un rischio moderato. Sebbene la situazione non sia critica, è importante ottimizzare al più presto per prevenire possibili problemi futuri. Questo test non invasivo offre una panoramica preliminare: continua a monitorare regolarmente per mantenere la sicurezza.",
          green: "✅ Ottimo! La tua configurazione di sicurezza web è solida e protegge adeguatamente i tuoi servizi. Questo test non invasivo conferma che i tuoi servizi sono ben configurati. Continua a monitorare regolarmente per mantenere questo livello di protezione e prevenire nuove minacce. Ottimo lavoro!"
        },
        finale: {
          red: "❌ Protezione insufficiente! La sicurezza complessiva del tuo dominio presenta gravi lacune. Sono state rilevate esposizioni significative nei servizi di posta e/o web, che potrebbero essere sfruttate per attacchi o accessi non autorizzati. Questo test si basa su dati pubblici e fornisce una panoramica preliminare: consigliamo di richiedere il report completo per identificare e correggere tutti i problemi critici.",
          yellow: "⚠️ Protezione parziale! La tua configurazione di sicurezza è discreta, ma ci sono ancora aree vulnerabili che richiedono attenzione. Migliorare alcuni aspetti specifici potrebbe fare una grande differenza per la protezione complessiva del tuo dominio. Questo test è basato su dati pubblici: approfondisci con il report completo per ottenere una checklist dettagliata delle azioni necessarie.",
          green: "✅ Protezione solida! La sicurezza complessiva del tuo dominio è ben configurata, con solo pochi dettagli da ottimizzare per raggiungere il massimo livello di protezione. Mantieni alta l’attenzione e valuta di richiedere il report completo per una verifica approfondita e per prevenire nuove minacce.",
          perfect: "🎉 Eccellente! Il tuo dominio è completamente sicuro e protetto. Le configurazioni di posta e web sono impeccabili, garantendo una difesa ottimale contro minacce e utilizzi non autorizzati. Tuttavia, la sicurezza è un processo continuo: richiedi il report completo per documentare il tuo stato attuale e assicurarti di mantenere questo livello di eccellenza."
        }
      };

      let category;
      if (type === 'web') {
        if (score <= 33) category = "red";
        else if (score <= 66) category = "yellow";
        else category = "green";
      } else {
        if (score <= 59) category = "red";
        else if (score <= 79) category = "yellow";
        else if (score <= 99) category = "green";
        else category = "perfect";
      }
      console.log(`category: ${category}`);
      return labels[type][category];
    };

    const hasMoreSubdomains = computed(() => {
      console.log(`subdomainRecords.length: ${subdomainRecords.value.length}, totalSubdomains: ${totalSubdomains.value}`);
      return subdomainStart.value < totalSubdomains.value;
    });
    
    const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    };

    const submitForm = async () => {
      if (!isFormValid.value) {
        toast.error("Inserisci un nome ed e-mail validi per procedere con l'analisi.", {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return
      }

      isSubmittingForm.value = true;
      try {
        await handleShodanUpdate();

        if (!historyID.value) {
          console.error('History ID is not set. Cannot update history.');
          return;
        }

        const _fbp = getCookie('_fbp');
        const _fbc = getCookie('_fbc');
        const userAgent = navigator.userAgent;
        const currentPageUrl = window.location.href;

        const token = await executeRecaptcha();

        const payload = { 
          nome: nome.value,
          email: email.value,
          event_name: "Lead",
          _fbp: _fbp,
          _fbc: _fbc,
          user_agent: userAgent,
          recaptchaToken: token,
          page_url: currentPageUrl
        };

        const response = await axios.put(`${process.env.VUE_APP_BACKEND_URL}/api/history-update/${historyID.value}/`, payload);
        if (response.status === 200) {
          console.log('History updated with nome and email:', response.data);

          const eventID = response.data.event_id; // Get the eventID from the backend
          const eventName = response.data.event_name;
          // Fire the Facebook Pixel event using the same eventID for deduplication
          fbq('track', eventName, {
            eventID: eventID, // Use the eventID generated in the backend
          });
          console.log(`Evento ${eventName} inviato con eventID: ${eventID}`);

          emailInput.value = email.value
          showForm.value = false;
        }
      } catch (error) {
        console.error('Error updating history:', error);
        showErrorModal.value = true;
        return;
      }
    };

    const redirectStripe = () => {
      if (email.value) {
        const stripeLink = `${stripeBaseLink.value}?prefilled_email=${encodeURIComponent(email.value)}`;
        window.location.href = stripeLink;
      } else {
        console.error('Email is not provided, cannot prefill the Stripe link.');
      }
    };

    const handleReportGeneration = () => {
      showSuccessModal.value = true;
    };

    const handleEmailUpdate = async () => {
      if (!emailInput.value) return; // Assicurati che il form sia valido prima di procedere
      isCheckoutButtonDisabled.value = true;
      email.value = emailInput.value;

      const _fbp = getCookie('_fbp');
      const _fbc = getCookie('_fbc');
      const userAgent = navigator.userAgent;
      const currentPageUrl = window.location.href;

      const payload = {
        nome: nome.value,
        email: email.value,
        prezzoProdotto: prezzoProdotto.value,
        nomeProdotto: nomeProdotto.value,
        event_name: "AddToCart",
        _fbp: _fbp,
        _fbc: _fbc,
        user_agent: userAgent,
        page_url: currentPageUrl
      };

      console.log('Request Data for Report Generation:', payload);

      try {
        const response = await axios.put(`${process.env.VUE_APP_BACKEND_URL}/api/history-update/${historyID.value}/`, payload);
        if (response.status === 200) {
          const eventID = response.data.event_id; // Get the eventID from the backend
          const eventName = response.data.event_name;
          // Fire the Facebook Pixel event using the same eventID for deduplication
          fbq('track', eventName, {
            eventID: eventID, // Use the eventID generated in the backend
          });
          console.log(`Evento ${eventName} inviato con eventID: ${eventID}`);
        }
      } catch (error) {
        console.error('Error updating history:', error);
        showErrorModal.value = true;
        return;
      }

      redirectStripe(); // Procedi al checkout
    };

    return {
      t,
      dominioInserito,
      historyID,
      successOptions: { animationData: animationSuccess },
      failureOptions: { animationData: animationFailure },
      showErrorModal,
      showDKIMErrorModal,
      showSuccessModal,
      checkDomainAnimation,
      showResults,
      showForm,
      checkSubdomainAnimation,
      handleFormSubmission,
      isDomainValid,
      handleReportGeneration,
      emailInput,
      handleEmailUpdate,
      redirectStripe,
      dominio,
      nome,
      email,
      primoCheckbox,
      nsList,
      wsList,
      mxList,
      replicList,
      serviceRecords,
      getFlag,
      spfText,
      checks,
      mailSecurityText,
      webSecurityText,
      mailTrafficLight,
      webTrafficLight,
      mailBorderColorClass,
      webBorderColorClass,
      siteKeyreCAPTCHA,
      recaptchaRef,
      executeRecaptcha,
      isFormValid,
      isSubmittingForm,
      isCheckoutButtonDisabled,
      submitForm,
      handleSuccess,
      handleError,
      spfScore,
      dmarcScore,
      dkimScore,
      mediaMailScore,
      shodan_score,
      finaleScore,
      getLabelText,
      numberOfAllowedIps,
      subdomainRecords,
      subdomainStart,
      totalSubdomains,
      fetchMoreSubdomains,
      hasMoreSubdomains,
      dkimStatus,
      handleDkimCheck,
      selectorsOptions,
      selectorsMultiselect1,
      modificaTestoMultiselect,
      showSuggestionMultiselect,
      selectorsMultiselect2,
      handleShodanUpdate,
      shodanAnimationInterval,
      showMouseOverMessage,
      valoreProdotto,
      prezzoProdotto,
      valuta,
      handleTimerEnd,
      errorMessage,
      currency
    };
  }
};
</script>

<template>
  <div class="hero-section">
    <div class="language-selector-container">
      <!-- <LanguageSelector /> -->
      <!-- <b-button variant="info" size="lg" @click="goToCheckout">{{ $t('genera-report') }}</b-button> -->
    </div>
    <video class="hero-video" autoplay loop muted playsinline disablePictureInPicture>
      <source src="@/assets/video/background.mp4" type="video/mp4" />
    </video>
    <div class="centered-content">
      <div class="rectangle">{{ $t('titolo') }}</div>
      <div class="subtitle">{{ $t('sottotitolo') }}
        <ul class="benefits-list">
          <li>✅ <strong>Controllo immediato</strong> → Scopri problemi anche se non sei un tecnico.</li>
          <li>🚨 <strong>Proteggi la tua reputazione</strong> → Evita che il tuo dominio venga usato per truffe.</li>
          <li>⚠️ <strong>Individua errori nascosti</strong> → Gli hacker sfruttano configurazioni errate.</li>
          <li>🛡️ <strong>Evita danni costosi</strong>→ Un semplice test oggi può salvarti migliaia di {{ currency }}.</li>
        </ul>
        <form @submit.prevent="handleFormSubmission">
          <p class="input-label">Inserisci il dominio da analizzare (es. miodominio.com)</p>
          <div class="d-flex flex-column flex-md-row align-items-center mb-4">
            <input type="text" v-model="dominioInserito" class="form-control me-2 mb-2 mb-md-0" :placeholder="$t('placeholder')" />
            <BButtonGroup class="hide-on-mobile">
              <BDropdown variant="info" :text="t('toggleMultiselect')" :auto-close="false" end id="dropdownMenuClickable" menu-class="bg-dark">
                <div class="p-2 width-multiselect">
                  <Multiselect class="mb-5" v-model="selectorsMultiselect1" id="multiselect1" mode="tags" :close-on-select="false" :searchable="true" :create-option="true" :options="selectorsOptions"
                    :placeholder="$t('select-dkim-placeholder')" :noOptionsText="$t('pressEnterToConfirmYour')" :noResultsText="$t('pressEnterToConfirmYour')" @search-change="modificaTestoMultiselect" />
                  <div v-if="showSuggestionMultiselect" style="color: white;">
                    <em>{{ $t('pressEnterToConfirmYour') }}</em>
                  </div>
                </div>
                <div class="text-center">
                  <b-button variant="danger" type="submit">{{ $t('bottone') }}</b-button>
                </div>
              </BDropdown>
            </BButtonGroup>
          </div>
          <b-button variant="danger" type="submit">{{ $t('bottone') }}</b-button>
        </form>
      </div>
    </div>
    <ScrollArrow v-if="showResults" />
  </div>

  <VueRecaptcha v-if="siteKeyreCAPTCHA" ref="recaptchaRef" :sitekey="siteKeyreCAPTCHA" size="invisible" @verify="handleSuccess" @error="handleError" />

  <div v-if="showResults">
    <h1>{{ dominio }}</h1>
    <template v-if="dkimStatus === 'failed'">
      <h2>{{ $t('dkim_check_failed') }}</h2>
      <div class="result-box border-red" style="flex-direction: column;">
        <p>{{ $t('select_dkim_selectors') }}</p>
        <Multiselect class="mb-5" v-model="selectorsMultiselect2" id="multiselect2" mode="tags" :close-on-select="false" :searchable="true" :create-option="true" :options="selectorsOptions" 
          :placeholder="$t('select-dkim-placeholder')" :noOptionsText="$t('pressEnterToConfirmYour')" :noResultsText="$t('pressEnterToConfirmYour')" @search-change="modificaTestoMultiselect" style="color: black;"/>
        <div v-if="showSuggestionMultiselect"><em>{{ $t('pressEnterToConfirmYour') }}</em></div>
        <div class="d-flex gap-2">
          <b-button variant="danger" @click="handleDkimCheck">{{ $t('check_dkim_button') }}</b-button>
          <b-button variant="light" @click="dkimStatus = null">{{ $t('cancel_dkim_button') }}</b-button>
        </div>
      </div>
    </template>
    <template v-if="serviceRecords && serviceRecords.length > 0">
      <h2>{{ $t('tuoservizio') }}</h2>
      <div style="position: relative;">
        <ResultBox v-for="(serviceItem, index) in serviceRecords" :key="index" :title="serviceItem[0]?.toUpperCase()" :data="serviceItem[1]" 
          :borderClass="webBorderColorClass" :isAnimating="shodanAnimationInterval !== null" :getFlag="getFlag"  @mouseover="showMouseOverMessage = true" @mouseleave="showMouseOverMessage = false" />
        <div v-if="showMouseOverMessage && shodanAnimationInterval !== null" class="mouse-over-text" :class="webBorderColorClass" >
          <i class="la la-exclamation-triangle" style="color: yellow; "> </i> {{ $t('testo-poup-attenzione') }}
        </div>
      </div>
    </template>

    <h2>{{ $t('nameserver') }}</h2>
    <div class="result-box form-container width-descrizione">
      <p>ℹ️ Recuperiamo i server DNS configurati per il tuo dominio utilizzando esclusivamente dati pubblici. Questo ci consente di identificare vulnerabilità o errori potenziali senza eseguire test diretti, permettendoti di verificare facilmente le configurazioni.</p>
      <p>⚠️ Per accedere ai risultati completi, richiediamo l’inserimento di una email per impedire accessi automatici e garantire un uso corretto del sistema.</p>
    </div>
    <template v-if="nsList && nsList.length">
      <div style="position: relative;">
        <ResultBox v-for="(nsItem, index) in nsList" :key="index" :title="nsItem[0]?.toUpperCase().slice(0, -1)" :data="nsItem[1]" 
          :borderClass="webBorderColorClass" :isAnimating="shodanAnimationInterval !== null" :getFlag="getFlag" @mouseover="showMouseOverMessage = true" @mouseleave="showMouseOverMessage = false" />
        <div v-if="showMouseOverMessage && shodanAnimationInterval !== null" class="mouse-over-text" :class="webBorderColorClass" >
          <i class="la la-exclamation-triangle" style="color: yellow; "> </i> {{ $t('testo-poup-attenzione') }}
        </div>
      </div>
    </template>
    <div v-else class="result-box" :class="webBorderColorClass">
      <p>{{ $t('nomatch') }}</p>
    </div>

    <h2>{{ $t('webserver') }}</h2>
    <div class="result-box form-container width-descrizione">
      <p>ℹ️ Valutiamo la sicurezza dei servizi collegati al tuo dominio (come siti web e applicazioni) basandoci su configurazioni pubbliche. Identifichiamo eventuali vulnerabilità conosciute in base alle tecnologie rilevate. Non effettuiamo test diretti o attività invasive.</p>
      <p>⚠️ Per accedere ai risultati completi, richiediamo l’inserimento di una email per impedire accessi automatici e garantire un uso corretto del sistema.</p>
    </div>
    <template v-if="wsList && wsList.length">
      <div style="position: relative;">
        <ResultBox v-for="(wsItem, index) in wsList" :key="index" :title="wsItem[0]?.toUpperCase()" :data="wsItem[1]" 
          :borderClass="webBorderColorClass" :isAnimating="shodanAnimationInterval !== null" :getFlag="getFlag" @mouseover="showMouseOverMessage = true" @mouseleave="showMouseOverMessage = false" />
        <div v-if="showMouseOverMessage && shodanAnimationInterval !== null" class="mouse-over-text" :class="webBorderColorClass" >
          <i class="la la-exclamation-triangle" style="color: yellow; "> </i> {{ $t('testo-poup-attenzione') }}
        </div>
      </div>
    </template>
    <div v-else class="result-box" :class="webBorderColorClass">
      <p>{{ $t('nomatch') }}</p>
    </div>

    <h2>{{ $t('mailserver') }}</h2>
    <div class="result-box form-container width-descrizione">
      <p>ℹ️ Valutiamo le configurazioni pubbliche dei server utilizzati per la ricezione delle email del tuo dominio. Eventuali errori o configurazioni deboli potrebbero compromettere la capacità di ricevere email in modo sicuro, esponendo il dominio a rischi di spam, phishing o perdita di comunicazioni importanti.</p>
    </div>
    <template v-if="mxList && mxList.length">
      <ResultBox v-for="(mxItem, index) in mxList" :key="index" :title="mxItem[0]?.toUpperCase()" :data="mxItem[1]" 
        :borderClass="mailBorderColorClass" :isAnimating="false" :getFlag="getFlag" />
    </template>
    <div v-else class="result-box" :class="mailBorderColorClass">
      <p>{{ $t('nomatch') }}</p>
    </div>

    <h2>{{ $t('servizidipostaelettronicainvio') }}</h2>
    <div class="result-box form-container width-descrizione">
      <p>ℹ️ Verifichiamo le configurazioni pubbliche legate all'invio di email del tuo dominio. Configurazioni errate possono consentire a malintenzionati di inviare email non autorizzate a tuo nome, danneggiando la reputazione e facilitando truffe come il phishing o, ancora peggio, impersonificando la tua azienda.</p>
    </div>
    <template v-if="spfText && spfText.length > 0">
      <ResultBox v-for="(spfItem, index) in spfText" :key="index" :title="spfItem[0]?.toUpperCase()" :data="spfItem[1]" 
        :borderClass="mailBorderColorClass" :isAnimating="false" :getFlag="getFlag" />
      <div style="text-align: center;">
        <p>{{ numberOfAllowedIps }} {{ $t('inidrizziippossonoinviare') }}</p>
      </div>
    </template>
    <div v-else class="result-box" :class="mailBorderColorClass"> <p>{{ $t('nomatch') }}</p> </div>

    <template v-if="replicList && replicList.length > 0">
      <h2>{{ $t('repliche') }}</h2>
      <div class="result-box form-container width-descrizione">
        <p>ℹ️ Identifichiamo eventuali punti in cui i tuoi dati potrebbero essere replicati o distribuiti, analizzando le nazioni associate alle configurazioni rilevate.</p>
        <p>⚠️ Per accedere ai risultati completi, richiediamo l’inserimento di una email per impedire accessi automatici e garantire un uso corretto del sistema.</p>
      </div>
      <div style="position: relative;">
        <ResultBox v-for="(replicItem, index) in replicList" :key="index" :title="replicItem[0]?.toUpperCase()" :data="replicItem[1]" 
          :borderClass="webBorderColorClass" :isAnimating="shodanAnimationInterval !== null" :getFlag="getFlag" @mouseover="showMouseOverMessage = true" @mouseleave="showMouseOverMessage = false" />
        <div v-if="showMouseOverMessage && shodanAnimationInterval !== null" class="mouse-over-text" :class="webBorderColorClass" >
          <i class="la la-exclamation-triangle" style="color: yellow; "> </i> {{ $t('testo-poup-attenzione') }}
        </div>
      </div>
    </template>

    <h2>{{ $t('subdomains') }}</h2>
    <div class="result-box form-container width-descrizione">
      <p>ℹ️ Valutiamo eventuali servizi aggiuntivi collegati al tuo dominio, come API, sottodomini o piattaforme di terze parti. Questi servizi possono rappresentare potenziali punti di ingresso per malintenzionati, soprattutto se non adeguatamente protetti, configurati oppure aggiornati.</p>
      <p>⚠️ Per accedere ai risultati completi, richiediamo l’inserimento di una email per impedire accessi automatici e garantire un uso corretto del sistema.</p>
    </div>
    <template v-if="subdomainRecords && subdomainRecords.length > 0">
      <div style="position: relative;">
        <ResultBox v-for="(subdomain, index) in subdomainRecords.slice(0, subdomainStart)" :key="index" :title="subdomain[0]?.toUpperCase()" :data="subdomain[1]" 
          :borderClass="webBorderColorClass" :isAnimating="shodanAnimationInterval !== null" :getFlag="getFlag" @mouseover="showMouseOverMessage = true" @mouseleave="showMouseOverMessage = false" />
        <div v-if="showMouseOverMessage && shodanAnimationInterval !== null" class="mouse-over-text" :class="webBorderColorClass" >
          <i class="la la-exclamation-triangle" style="color: yellow; "> </i> {{ $t('testo-poup-attenzione') }}
        </div>
      </div>
      <div style="text-align: center;">
        <p>{{ $t('sottodominiinmostra') }}: {{ subdomainRecords.length }}, {{ $t('sottodominianalizzati') }}: {{ subdomainStart }}, {{ $t('sottodominitotali') }}: {{ totalSubdomains }}</p>
      </div>
      <div class="row mt-3">
        <div class="col-12 d-flex justify-content-center">
          <BButton variant="info" :disabled="checkSubdomainAnimation" v-if="hasMoreSubdomains" @click="fetchMoreSubdomains"> {{ $t('load_more') }} </BButton>
        </div>
        <div class="col-12 d-flex justify-content-center mt-2" v-if="checkSubdomainAnimation">
          <div class="pong-loader"></div>
        </div>
      </div>
    </template>
    <div v-else class="result-box" :class="webBorderColorClass"> <p>{{ $t('nomatch') }}</p> </div>
    <template v-if="checks && checks.length > 0">
      <hr>
      <h2>{{ $t('securityprecheck') }}</h2>
      <div id="traffic-light">
        <div class="light red" :class="{ active: mailTrafficLight === 'red' }"></div>
        <div class="light yellow" :class="{ active: mailTrafficLight === 'yellow' }"></div>
        <div class="light green" :class="{ active: mailTrafficLight === 'green' }"></div>
      </div>
      <div class="result-box" :class="mailBorderColorClass"> <p v-html="mailSecurityText"></p> </div>
      <hr>
      <h2>{{ $t('shodancheck') }}</h2>
      <div id="traffic-light">
        <div class="light red" :class="{ active: webTrafficLight === 'red' }"></div>
        <div class="light yellow" :class="{ active: webTrafficLight === 'yellow' }"></div>
        <div class="light green" :class="{ active: webTrafficLight === 'green' }"></div>
      </div>

      <div v-if="showForm" class="result-box form-container" :class="webBorderColorClass">
        <h3>🔍 Stiamo controllando ogni angolo del tuo dominio con i dati pubblici accessibili a chiunque</h3>
        <p>Abbiamo analizzato il tuo dominio e i servizi collegati, inclusi eventuali sottodomini. Questo controllo ci permette di individuare:</p>
        <p>✅ Servizi o informazioni esposte che chiunque può vedere.</p>
        <p>⚠️ Problemi di sicurezza che potrebbero essere sfruttati per danneggiare la tua azienda.</p>
        <br>
        <p>Anche piccoli errori possono rappresentare grandi rischi. Non serve essere esperti: ti spiegheremo tutto in modo chiaro e comprensibile.</p>
        <p>🛑 Ti senti al sicuro? Potresti essere esposto senza saperlo. 🛑</p>
        <p>⚠️ I test eseguiti fino ad ora verificano solo alcuni parametri, ma NON ti dice se il tuo dominio è veramente protetto.</p>
        <p>🔍 <strong>Inserisci la tua email</strong> per visualizzare i risultati e capire se ci sono rischi nascosti che devi risolvere.</p>

        <div class="input-group my-3">
          <span class="input-group-text"><i class="ri-user-fill me-2"></i>{{ $t('nome') }}</span>
          <input type="text" class="form-control" v-model="nome" :placeholder="$t('placeholdernome')" autocomplete="off" required>
        </div>
        <div class="input-group mb-3">
          <span class="input-group-text"><i class="ri-mail-fill me-2"></i>E-mail</span>
          <input type="email" class="form-control" v-model="email" :placeholder="$t('placeholderemail')" autocomplete="off" required>
        </div>
        <div class="form-check mb-3">
          <input class="form-check-input" type="checkbox" v-model="primoCheckbox" id="consentCheckbox">
          <label class="form-check-label" for="consentCheckbox">{{ $t('home2_checkbox') }}</label>
        </div>
        <BButton variant="warning" class="mx-auto" :disabled="isSubmittingForm" @click="submitForm">{{ isSubmittingForm ? 'Verifica in corso...' : $t('pulsante_form') }}</BButton>
      </div>
      <div v-else>
        <div class="result-box" :class="webBorderColorClass">
          <p v-html="webSecurityText"></p>
        </div>
        <hr>
        <h1>Valutazione della sicurezza per {{ dominio }}</h1>

        <div class="result-box form-container" :class="mailBorderColorClass">
          <h3>Protezione della tua Email</h3>
          <p> Analizziamo i sistemi che proteggono l'invio e la ricezione delle email del tuo dominio. Una protezione incompleta può permettere a chiunque di inviare email a tuo nome, danneggiando la tua reputazione. </p>
        </div>
        <div class="gauges-container">
          <Gauge :score="spfScore" :label1="$t('spf_1')" :label2="getLabelText(spfScore, 'spf')" />
          <Gauge :score="dkimScore" :label1="$t('dkim_1')" :label2="getLabelText(dkimScore, 'dkim')" />
          <Gauge :score="dmarcScore" :label1="$t('dmarc_1')" :label2="getLabelText(dmarcScore, 'dmarc')" />
        </div>
        <div class="gauge-container-larger">
          <Gauge :score="mediaMailScore" :label1="$t('avg_1')" :label2="getLabelText(mediaMailScore, 'avg')" />
        </div>

        <div class="result-box form-container" :class="webBorderColorClass">
          <h3>Protezione dei tuoi Servizi Web</h3>
          <p> Verifichiamo se i tuoi servizi e accessi web (siti, software aziendali, servizi remoti) sono esposti e potenzialmente vulnerabili. Un’adeguata protezione evita accessi non autorizzati e rischi di attacchi. </p>
        </div>
        <div class="gauge-container-larger">
          <Gauge :score="shodan_score" :label1="$t('shodan_1')" :label2="getLabelText(shodan_score, 'web')" :equalDivision="true"/>
        </div>

        <div class="result-box form-container border-gray">
          <h3>Stato complessivo di protezione dominio</h3>
          <p> Riepilogo del livello di sicurezza rilevato per il tuo dominio. Questo valore rappresenta la media tra la protezione dei servizi email e dei servizi web. </p>
        </div>
        <div class="gauge-container-larger">
          <Gauge :score="finaleScore" :label1="$t('finale-label1-gauge')" :label2="getLabelText(finaleScore, 'finale')" />
        </div>

        <hr>
        <div class="subtitle centered-container">
          <img src="@/assets/images/altri/arrows.gif" class="centrato">
          <h1>Cosa fare ora? Proteggi il tuo dominio con il Report Completo!</h1>
          <p> Il nostro Report Completo ti offre un'analisi approfondita della sicurezza del tuo dominio e dei servizi collegati. Entro 24 ore, riceverai un documento dettagliato che: </p>
          <ul class="benefits-list">
            <li>✅ È chiaro e accessibile, anche se non sei un tecnico.</li>
            <li>✅ È perfetto per i professionisti che devono risolvere velocemente i problemi.</li>
            <li>✅ Include una checklist pratica con azioni consigliate per migliorare la sicurezza.</li>
          </ul>
          <p><strong>💡 Perché è importante?</strong></p>
          <p> Un report è fondamentale, indipendentemente dal risultato: </p>
          <ul class="benefits-list">
            <li>✅ Se tutto è ok, è la prova che la tua configurazione è sicura e puoi aggiungerlo alla tua documentazione aziendale.</li>
            <li>✅ Se ci sono problemi, avrai tutte le informazioni necessarie per intervenire immediatamente e proteggere la tua azienda.</li>
          </ul>
          <p><strong>Valore del Report:</strong></p>
          <ul class="benefits-list">
            <li>💸 Valore del report: <b>{{ valuta }} {{ valoreProdotto }}.--</b></li>
            <li>🎯 Offerta Speciale fino allo scadere del timer <b>a soli <span style="color: red;"><s>{{ valuta }} {{ valoreProdotto }}.--</s></span> <span style="color: green;">{{ valuta }} {{ prezzoProdotto }}.--</span>!</b></li>
          </ul>
          <p><strong>Non lasciare nulla al caso!</strong></p>
          <p>Ordina il tuo report ora e metti al sicuro il tuo business.</p>
          <img src="@/assets/images/altri/arrows.gif" class="centrato">
          <FlipClock :idd="'flipclock1'" class="flip-clock-container" @closed="handleTimerEnd"/>
          <p>Prezzo di <span style="color: green;">{{ valuta }} {{ prezzoProdotto }}.--</span> BLOCCATO fino al raggiungimento dello ZERO</p>
          <b-button variant="success" size="lg" @click="handleReportGeneration" class="centrato mt-3">{{ $t('genera-report') }}</b-button>
        </div>
      </div>
    </template>
    <b-modal v-model="showErrorModal" hide-footer hide-header-close class="v-modal-custom" modal-class="zoomIn" centered no-close-on-backdrop>
      <div class="text-center">
        <lottie :options="failureOptions" :height="120" :width="120"/>
        <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
          <h4 style="color: black;">{{ $t('errore-analisi-dominio-titolo') }}</h4>
          <p class="text-muted mx-4 mb-4">{{ errorMessage }}</p>
          <!-- <p class="text-muted mx-4 mb-4">{{ $t('errore-analisi-dominio-descrizione') }}</p> -->
        </div>
        <b-button variant="info" @click="showErrorModal = false">{{ $t('chiudi') }}</b-button>
      </div>
    </b-modal>
    <b-modal v-model="showDKIMErrorModal" hide-footer hide-header-close class="v-modal-custom" modal-class="zoomIn" centered no-close-on-backdrop>
      <div class="text-center">
        <lottie :options="failureOptions" :height="120" :width="120"/>
        <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
          <h4 style="color: black;">{{ $t('errore-analisi-selettore-dkim') }}</h4>
          <p class="text-muted mx-4 mb-4">{{ $t('errore-analisi-selettore') }}</p>
        </div>
        <b-button variant="info" @click="showDKIMErrorModal = false">{{ $t('chiudi') }}</b-button>
      </div>
    </b-modal>
    <b-modal v-model="showSuccessModal" hide-footer class="v-modal-custom" modal-class="zoomIn" centered >
      <div class="text-center">
        <lottie :options="successOptions" :height="120" :width="120" />
        <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
          <h4 style="color: black;">{{ $t('successo-dati-memorizzati-titolo') }}</h4>
          <p class="text-muted mx-4 mb-4">
            Per evitare problemi con l'elaborazione del tuo <strong>Report Completo</strong>, comparirà lo stesso indirizzo email che vedi qui sotto.
            Se questa email è corretta, puoi procedere con il checkout in sicurezza. In caso di errore, correggi l'indirizzo email.</p>
            <p class="text-muted mx-4 mb-4">📧 Email fornita:
              <b-form-input id="email-input" v-model="emailInput" type="email" required></b-form-input>
            </p>
        </div>
        <b-button variant="success" class="mt-3" @click="handleEmailUpdate" :disabled="isCheckoutButtonDisabled">{{ isCheckoutButtonDisabled ? $t('elaborazione') : $t('checkout') }}</b-button>
      </div>
    </b-modal>
  </div>

  <Footer />
  <div v-if="checkDomainAnimation" class="overlay">
    <div class="pong-loader" style="transform: scale(4);"></div>
  </div>
</template>

<style scoped>

.result-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #0d1b2a;
  padding: 10px;
  margin: 5px 0;
  border-radius: 5px;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 768px) {
  .result-box {
    width: 90%; /* Width for mobile */
  }
}

.form-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

@media (min-width: 769px) {
  .width-descrizione {
    width: 38%;
    margin-bottom: 10px;
  }
}
.border-green {
  border: 1px solid #00ff00;
}

.border-yellow {
  border: 1px solid #ffff00;
}

.border-red {
  border: 1px solid #ff0707;
}

.border-gray {
  border: 1px solid #ffffff;
}

#traffic-light {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px auto;
  border: 2px solid white;
  border-radius: 8px;
  padding: 7px;
  width: fit-content;
}

.light {
  width: 50px;
  height: 50px;
  margin: 0 10px;
  border-radius: 50%;
  opacity: 0.3;
  transition: opacity 0.2s;
}

.light.active {
  opacity: 1;
}

.red {
  background: red;
}

.yellow {
  background: yellow;
}

.green {
  background: rgb(0, 255, 0);
}

p {
  margin: 0; /* Remove margin */
}

h1, h2 {
  text-align: center;
  margin-top: 5rem;
}

h1 {
  margin-bottom: 3rem;
}

.hero-section {
  position: relative;
  margin: 0;
  padding: 0;
  min-height: 100vh; /* Usa min-height per adattare tutto */
  height: auto; /* Permette al contenuto di espandersi */
  overflow: hidden;
}

.hero-video {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.centered-content {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 1;
  padding: 20px;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .centered-content {
    position: relative;
  }
}

.language-selector-container {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
}

.rectangle {
  display: inline-block;
  padding: 0px 10px;
  border: 8px solid white;
  color: white;
  font-size: 4rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .rectangle {
    font-size: 3.2rem;
  }
}

.subtitle {
  color: white;
  font-size: 1.5rem;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  max-width: 870px;
  padding: 20px; /* Margini interni */
  margin-bottom: 80px;
}

@media (min-width: 769px) {
  .subtitle {
    margin: 28px; /* Margini esterni */
  }
}

.centered-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;
}

.benefits-list {
  font-size: 1.2rem;
  list-style: none; /* Nasconde i punti dell'elenco puntato */
  text-align: left; /* Imposta l'orientamento a sinistra */
  margin-top: 20px;
  padding: 0; /* Rimuove il padding del contenitore ul */
}

.input-label {
  text-align: left; /* Allinea il testo a sinistra */
  font-size: 1rem; /* Adatta la dimensione del testo */
}

.width-multiselect {
    width: 52rem;
}

/* Stile specifico per dispositivi mobili */
@media (max-width: 768px) {
  .width-multiselect {
    width: 100vw;
  }
}

.mouse-over-text { 
  position: absolute; /* Posizionamento relativo all'elemento padre */
  z-index: 100; /* Garantisce che sia sopra tutti gli altri elementi */
  background: rgba(0, 0, 0, 0.7); /* Sfondo scuro per evidenziare il testo */
  color: white;
  border-radius: 10px; /* Angoli arrotondati per un aspetto più moderno */
  font-size: 1rem;
  text-align: center;
  pointer-events: none; /* Evita che interferisca con i clic */
  max-width: 500px; /* Imposta una larghezza massima */
  word-wrap: break-word; /* Consente il wrapping del testo se troppo lungo */
  top: 50%; /* Centra verticalmente nel result box */
  left: 50%; /* Centra orizzontalmente nel result box */
  transform: translate(-50%, -50%); /* Regola la posizione esattamente al centro */
}

.gauges-container {
  transform: scale(1.1);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 35px auto;
  width: 60%;
  gap: 60px;
}

@media (max-width: 768px) {
  .gauges-container {
    gap: 0px;
  }
}

.gauge-container-larger {
  transform: scale(1.6);
  margin: 150px auto; /* Margine più grande per il gauge principale */
  width: fit-content;
}

.centrato {
  display: block;
  margin: 0 auto;
  width: 500px;
  max-width: 100%; /* Assicura che l'immagine non superi la larghezza del contenitore */
  height: auto;
}

@media (max-width: 768px) {
  .flip-clock-container {
    transform: scale(2.9);
    margin: 60px auto; /* Spaziatura verticale */
  }
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

@media (max-width: 768px) {
  .hide-on-mobile {
    display: none !important;
  }
}
</style>
